<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Sök
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Sökfältet visas som ikon i navigeringsfältet och som ett expanderat fält i
      Alla recept-sektionen.
    </p>

    <PreviewBox label="Inline sökfält" bg="#f8fafa">
      <div
        class="flex items-center gap-2.5 px-4 py-3 bg-white rounded-2xl w-full max-w-[400px]"
        style="border: 1.5px solid #eceef0"
      >
        <Search :size="18" color="#a0b0ae" />
        <input
          v-model="query"
          type="text"
          placeholder="Sök efter recept..."
          class="border-none outline-none font-[Plus_Jakarta_Sans] text-[15px] text-[#191c1e] w-full bg-transparent"
        />
        <button
          v-if="query"
          class="bg-none border-none cursor-pointer p-0"
          @click="query = ''"
        >
          <X :size="14" color="#a0b0ae" />
        </button>
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Search, X } from "lucide-vue-next";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="flex items-center gap-2.5 px-4 py-3 bg-white rounded-2xl" style="border: 1.5px solid #eceef0">
  <Search :size="18" color="#a0b0ae" />
  <input
    v-model="query"
    type="text"
    placeholder="Sök efter recept..."
    class="border-none outline-none font-[Plus_Jakarta_Sans] text-[15px] w-full bg-transparent"
  />
  <button v-if="query" @click="query = ''" class="border-none bg-transparent cursor-pointer p-0">
    <X :size="14" color="#a0b0ae" />
  </button>
</div>`;
const cssCode = `/* Sök-container */
background: white;
border: 1.5px solid #eceef0;
border-radius: 14px;
padding: 12px 16px;   /* py-3 px-4 */

/* Sökikon */
/* Search från lucide-vue-next */
color: #a0b0ae;
width: 18px;
height: 18px;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const query = ref("");
</script>
